export const en = {
    common: {
        appName: 'WooConnect',
        loading: 'Loading...',
        save: 'Save',
        cancel: 'Cancel',
        delete: 'Delete',
        edit: 'Edit',
        create: 'Create',
        search: 'Search',
        filter: 'Filter',
        refresh: 'Refresh',
        retry: 'Retry',
        confirm: 'Confirm',
        back: 'Back',
        next: 'Next',
        yes: 'Yes',
        no: 'No',
        all: 'All',
        none: 'None',
        noResults: 'No results found',
        error: 'Something went wrong',
        success: 'Success',
        required: 'Required',
        optional: 'Optional',
        comingSoon: 'Coming Soon',
        comingSoonDescription: 'Coming in next update',
        actions: 'Actions',
        view: 'View',
        close: 'Close',
        done: 'Done',
        add: 'Add',
        update: 'Update',
        enable: 'Enable',
        disable: 'Disable',
        active: 'Active',
        inactive: 'Inactive',
        suspended: 'Suspended',
        showing: 'Showing',
        of: 'of',
        perPage: 'per page',
        viewAll: 'View All',
        notFound: 'Page not found',
        backToDashboard: 'Back to Dashboard',
        selected: 'selected',
        noData: 'No data available',
        description: 'Description',
        type: 'Type',
        date: 'Date',
        amount: 'Amount',
        reason: 'Reason',
        details: 'Details',
        name: 'Name',
        email: 'Email',
        phone: 'Phone',
        address: 'Address',
        company: 'Company',
        status: 'Status',
        role: 'Role',
        version: 'Version',
        features: 'Features',
        slug: 'Slug',
        price: 'Price',
        created: 'Created',
        from: 'From',
        to: 'To',
        expires: 'Expires',
        confirmDelete: 'Are you sure you want to delete this?',
        lastLogin: 'Last Login',
        remove: 'Remove',
        assign: 'Assign',
        connect: 'Connect',
        disconnect: 'Disconnect',
        test: 'Test',
    },
    auth: {
        login: 'Log In',
        logout: 'Log Out',
        email: 'Email',
        password: 'Password',
        forgotPassword: 'Forgot Password?',
        resetPassword: 'Reset Password',
        newPassword: 'New Password',
        confirmPassword: 'Confirm Password',
        currentPassword: 'Current Password',
        changePassword: 'Change Password',
        invalidCredentials: 'Invalid email or password',
        invalidEmail: 'Invalid email format',
        minPassword: 'Minimum 8 characters',
        sessionExpired: 'Your session has expired. Please log in again.',
    },
    nav: {
        dashboard: 'Dashboard',
        orders: 'Orders',
        products: 'Products',
        customers: 'Customers',
        analytics: 'Analytics',
        notifications: 'Notifications',
        settings: 'Settings',
        users: 'Users',
        subscriptions: 'Subscriptions',
        plugins: 'Plugins',
        ai: 'AI',
        auditLog: 'Audit Log',
        systemSettings: 'System Settings',
        apiDocs: 'API Docs',
        marketing: 'Marketing',
        roleDefaults: 'Role Defaults',
    },
    dashboard: {
        title: 'Dashboard',
        ordersToday: 'Orders Today',
        revenueToday: "Today's Revenue",
        revenueWeek: 'Weekly Revenue',
        revenueMonth: 'Monthly Revenue',
        totalProducts: 'Total Products',
        totalCustomers: 'Total Customers',
        recentOrders: 'Recent Orders',
        selectStore: 'Select Store',
        pending: 'Pending',
        processing: 'Processing',
        thisWeek: 'This Week',
        revenueChart: 'Revenue',
        lowStockAlert: 'Stock Alerts',
        lowStockDesc: '{{low}} low stock, {{out}} out of stock',
        loadTimeout: 'Could not load data. Check your connection and try again.',
    },
    orders: {
        title: 'Orders',
        order: 'Order',
        status: 'Status',
        customer: 'Customer',
        total: 'Total',
        date: 'Date',
        items: 'Items',
        notes: 'Notes',
        addNote: 'Add Note',
        addNotePlaceholder: 'Write a note...',
        changeStatus: 'Change Status',
        refund: 'Refund',
        refundAmount: 'Refund Amount',
        refundReason: 'Refund Reason',
        bulkUpdate: 'Bulk Update',
        noOrders: 'No orders yet',
        noNotes: 'No notes yet',
        showSystemNotes: 'Show technical notes',
        hideSystemNotes: 'Hide technical notes',
        subtotal: 'Subtotal',
        shipping: 'Shipping',
        tax: 'Tax',
        discount: 'Discount',
        payment: 'Payment',
        billing: 'Billing',
        billingAddress: 'Billing Address',
        shippingAddress: 'Shipping Address',
        sendToCustomer: 'Send to customer',
        customerNote: 'Customer Note',
        transactionId: 'Transaction ID',
        fees: 'Fees',
        refundsTitle: 'Refunds',
        dateCompleted: 'Completed',
        each: 'each',
        datePaid: 'Date Paid',
        confirmStatusChange: 'Change order {{orderNumber}} to "{{status}}"?',
        bulkConfirmStatusChange: 'Change {{count}} orders to "{{status}}"?',
        coupon: 'Coupon',
        statuses: {
            pending: 'Pending',
            processing: 'Processing',
            'on-hold': 'On Hold',
            completed: 'Completed',
            cancelled: 'Cancelled',
            refunded: 'Refunded',
            failed: 'Failed',
        },
    },
    products: {
        title: 'Products',
        name: 'Name',
        price: 'Price',
        regularPrice: 'Regular Price',
        salePrice: 'Sale Price',
        stock: 'Stock',
        stockQuantity: 'Stock Quantity',
        manageStock: 'Manage Stock',
        lowStockThreshold: 'Low Stock Threshold',
        category: 'Category',
        categories: 'Categories',
        tags: 'Tags',
        status: 'Status',
        lowStock: 'Low Stock',
        outOfStock: 'Out of Stock',
        inStock: 'In Stock',
        noProducts: 'No products yet',
        sku: 'SKU',
        published: 'Published',
        draft: 'Draft',
        simple: 'Simple',
        variable: 'Variable',
        quickEdit: 'Quick Edit',
        salePriceMustBeLower: 'Sale price must be lower than regular price',
        stockCannotBeNegative: 'Stock quantity cannot be negative',
        leaveEmptyToRemoveSale: 'Leave empty to remove sale',
        images: 'Images',
        description: 'Description',
        productInfo: 'Product Info',
        pricing: 'Pricing',
        inventory: 'Inventory',
        stockStatus: 'Stock Status',
        productType: 'Product Type',
        totalSales: 'Total Sales',
    },
    customers: {
        title: 'Customers',
        name: 'Name',
        email: 'Email',
        totalSpent: 'Total Spent',
        ordersCount: 'Orders',
        lastOrder: 'Last Order',
        noCustomers: 'No customers yet',
        segment: 'Segment',
        customerSince: 'Customer Since',
        averageOrder: 'Average Order Value',
        recentOrders: 'Recent Orders',
        profile: 'Profile',
        billingAddress: 'Billing Address',
        shippingAddress: 'Shipping Address',
        stats: 'Stats',
        syncNote: 'Customer stats (orders, spent) may need to be synced in WooCommerce Analytics.',
        segments: {
            vip: 'VIP',
            repeat: 'Repeat',
            new: 'New',
            inactive: 'Inactive',
        },
    },
    analytics: {
        attribution: 'Attribution',
        attributionRate: 'Attribution Rate',
        topSource: 'Top Source',
        topCampaign: 'Top Campaign',
        mobileShare: 'Mobile Share',
        sourceConversion: 'Source → Conversion',
        source: 'Source',
        campaigns: 'Campaigns',
        devices: 'Devices',
        attributionUnavailable: 'Attribution not available',
        attributionNeedsBridge: 'Attribution requires the WooConnect Bridge on this store.',
        attributionCoverageNote: 'Only {{pct}}% of orders carry attribution data; the rest show as Direct/Untracked.',
        title: 'Analytics',
        revenueThisMonth: 'Revenue This Month',
        ordersThisMonth: 'Orders This Month',
        averageOrderValue: 'Average Order Value',
        newCustomers: 'New Customers',
        revenue: 'Revenue',
        topSellers: 'Top Sellers',
        sales: 'Sales',
        statusBreakdown: 'Order Status Breakdown',
        customerAnalytics: 'Customer Analytics',
        period: 'Period',
        daily: 'Daily',
        weekly: 'Weekly',
        monthly: 'Monthly',
        days7: '7 Days',
        days14: '14 Days',
        days30: '30 Days',
        days90: '90 Days',
        advancedAnalytics: 'Advanced Analytics',
        advancedDescription: 'Advanced customer insights, revenue trends, and more.',
        learnMore: 'Learn More',
        viewAnalytics: 'View Analytics',
        sold: 'sold',
        noTopSellers: 'No top seller data',
        trend: 'Trend',
        days365: '1 Year',
        revenueComparison: 'Revenue Comparison',
        currentPeriod: 'Current Period',
        previousPeriod: 'Previous Period',
        metric: 'Metric',
        change: 'Change',
        paymentMethods: 'Payment Methods',
        noPaymentData: 'No payment data available',
        orders: 'Orders',
        customerStats: 'Customer Overview',
        totalCustomers: 'Total Customers',
        newThisMonth: 'New This Month',
        newLastMonth: 'New Last Month',
        topCustomersBySpend: 'Top Customers by Spend',
        noCustomerData: 'No customer data available',
        lowStockAlerts: 'Low Stock Alerts',
        lowStockItems: '{{count}} items low on stock',
        outOfStockItems: '{{count}} items out of stock',
        viewProducts: 'View Products',
        image: 'Image',
        product: 'Product',
        totalOrders: 'Total Orders',
        vsLastMonth: 'vs last month',
        // Tab labels
        overview: 'Overview',
        products: 'Products',
        customers: 'Customers',
        stock: 'Stock',
        coupons: 'Coupons',
        taxes: 'Taxes',
        // Date range
        dateRange: 'Date Range',
        compareTo: 'Compare to',
        previousYear: 'Previous Year',
        today: 'Today',
        yesterday: 'Yesterday',
        last7days: 'Last 7 days',
        last30days: 'Last 30 days',
        thisMonth: 'This Month',
        lastMonth: 'Last Month',
        thisQuarter: 'This Quarter',
        thisYear: 'This Year',
        customRange: 'Custom Range',
        // Revenue metrics
        grossSales: 'Gross Sales',
        netRevenue: 'Net Revenue',
        ordersCount: 'Orders',
        productsSold: 'Products Sold',
        insightBestDay: 'Best day',
        insightConcentration: 'Top 3 products drive',
        insightAov: 'Avg order value',
        unitsShort: 'units',
        netExclVat: 'Net revenue · excl. VAT',
        alertAovDrop: 'Average order value down {{value}}% vs previous period',
        alertRevenueDrop: 'Net revenue down {{value}}% vs previous period',
        alertHighRefunds: 'Refund rate is {{value}}%',
        alertLowAttribution: 'Only {{value}}% of orders carry attribution data',
        itemsSold: 'Items Sold',
        avgOrderValue: 'Avg Order Value',
        avgItemsPerOrder: 'Avg Items/Order',
        couponsUsed: 'Coupons Used',
        couponsAmount: 'Coupons Amount',
        shippingTotal: 'Shipping',
        taxesTotal: 'Taxes',
        refundsTotal: 'Refunds',
        vsLastPeriod: 'vs previous period',
        // Order Intelligence / Profit (Wave 2)
        profitMargin: 'Profit & Margin',
        grossProfit: 'Gross Profit',
        margin: 'Margin',
        cogs: 'Cost of Goods',
        costCoverage: 'Cost Coverage',
        costCoverageHint: 'of revenue has cost data',
        noCostData: 'No product cost data',
        noCostDataHint: 'Add cost of goods to your products to see profit and margin.',
        refunds: 'Refunds',
        refundRate: 'Refund Rate',
        refundsCount: 'Refunds',
        avgRefund: 'Avg Refund',
        avg: 'avg',
        orderValueDistribution: 'Order Value Distribution',
        topCustomersHint: 'Lifetime spend · customers active in this period',
        // Customer Intelligence (Wave 3)
        customerIntel: 'Customer Intelligence',
        returningCustomers: 'Returning',
        repeatRate: 'Repeat Rate',
        avgLifetimeValue: 'Avg LTV',
        ordersPerCustomer: 'orders/customer',
        topCustomersPeriod: 'Top Customers (this period)',
        periodSpend: 'Period Spend',
        rfmSegments: 'Customer Segments (RFM)',
        topCities: 'Top Cities',
        stockValue: 'Inventory Value',
        discountOfGross: '% of gross',
        browsers: 'Browsers',
        customersBySource: 'Customers by Source',
        landingPages: 'Landing Pages',
        cohorts: 'Cohort Retention',
        cohortsHint: '% of each acquisition month that ordered again',
        stockVelocity: 'Running Out Soon',
        daysLeft: 'days',
        inStockShort: 'in stock',
        alerts: 'Alerts',
        platinum: 'Platinum',
        gold: 'Gold',
        silver: 'Silver',
        bronze: 'Bronze',
        avgDaysBetween: 'Avg days between orders',
        avgRecency: 'Avg recency',
        lifetimeShort: 'lifetime',
        // Product Intelligence (Wave 4)
        topVariations: 'Top Variations',
        frequentlyBoughtTogether: 'Frequently Bought Together',
        // Sales Patterns (Wave 5)
        salesByDay: 'Sales by Day',
        peakHours: 'Peak Hours',
        shippingMethods: 'Shipping Methods',
        byCountry: 'By Country',
        // Abandoned Cart Recovery (Wave 6)
        abandonedCarts: 'Abandoned Cart Recovery',
        cartsCaptured: 'Carts Captured',
        recovered: 'recovered',
        recoveredValue: 'Recovered Value',
        lostValue: 'Lost Value',
        // Compare (Wave 7)
        compareTitle: 'Period Comparison',
        current: 'Current',
        // Products tab
        topProducts: 'Top Products',
        productName: 'Product',
        unitsSold: 'Units Sold',
        categoryBreakdown: 'Category Breakdown',
        category: 'Category',
        productsCount: 'Products',
        revenueByCategory: 'Revenue by Category',
        noProductData: 'No product data for this period',
        // Orders tab
        orderStatus: 'Order Status',
        netSales: 'Net Sales',
        avgItems: 'Avg Items',
        ordersByDay: 'Orders Over Time',
        statusBreakdownTitle: 'Status Breakdown',
        paymentMethodsTitle: 'Payment Methods',
        // Customers tab
        totalCustomersCount: 'Total Customers',
        avgOrders: 'Avg Orders',
        avgSpend: 'Avg Spend',
        topCustomersTitle: 'Top Customers',
        totalSpent: 'Total Spent',
        lastActive: 'Last Active',
        customersByLocation: 'Customers by Location',
        noCustomers: 'No customer data for this period',
        // Stock tab
        stockSummary: 'Stock Summary',
        inStock: 'In Stock',
        lowStockLabel: 'Low Stock',
        outOfStockLabel: 'Out of Stock',
        onBackorder: 'On Backorder',
        lowStockProducts: 'Low Stock Products',
        stockStatus: 'Status',
        quantity: 'Quantity',
        noStockData: 'No stock data available',
        // Coupons tab
        topCoupons: 'Top Coupons',
        couponCode: 'Coupon Code',
        discount: 'Discount',
        couponsOverTime: 'Coupons Over Time',
        totalDiscount: 'Total Discount',
        ordersWithCoupons: 'Orders with Coupons',
        noCouponData: 'No coupon data for this period',
        // Taxes tab
        taxRates: 'Tax Rates',
        taxRate: 'Rate',
        orderTax: 'Order Tax',
        shippingTax: 'Shipping Tax',
        totalTax: 'Total Tax',
        noTaxData: 'No tax data for this period',
        // Compare
        compare: 'Compare',
        difference: 'Difference',
        thisPeriod: 'This Period',
        fullAnalyticsInPanel: 'Full analytics in Panel',
        // VAT
        inclVat: '(incl. VAT)',
        exclVat: '(excl. VAT)',
        // Status filter
        statusFilter: 'Order Statuses',
        allStatuses: 'All Statuses',
        // Settings tab
        settings: 'Settings',
        settingsTitle: 'Analytics Settings',
        dateDisplay: 'Date & Display',
        defaultPreset: 'Default Period',
        dateColumnLabel: 'Date Column',
        dateCreated: 'Order Created',
        datePaid: 'Order Paid',
        dateCompleted: 'Order Completed',
        weekStartsOn: 'Week Starts On',
        monday: 'Monday',
        sunday: 'Sunday',
        // Order status settings
        orderStatusesTitle: 'Order Statuses',
        paidStatusesHelp: 'Which statuses count as PAID for revenue and sales. By default only In Progress and Completed are selected.',
        syncedFromWc: 'Synced from WooCommerce: {{count}} statuses ({{custom}} custom)',
        syncFromStore: 'Sync from Store',
        syncing: 'Syncing...',
        syncSuccess: 'Settings synced from store',
        customStatus: 'Custom',
        defaultStatus: 'Default',
        paid: 'Paid',
        unpaid: 'Unpaid',
        // Store info
        storeInfo: 'Store Info',
        taxesEnabledLabel: 'Taxes',
        hposEnabledLabel: 'HPOS',
        enabled: 'Enabled',
        disabled: 'Disabled',
        lastSynced: 'Last Synced',
        never: 'Never',
        settingsSaved: 'Analytics settings saved',
        // New presets
        last14days: 'Last 14 days',
        last90days: 'Last 90 days',
        last365days: 'Last 365 days',
        thisWeek: 'This Week',
        lastWeek: 'Last Week',
        // Compare tab
        compareDefaultPreset: 'Default Comparison',
        periodA: 'Period A',
        periodB: 'Period B',
        customDates: 'Custom Dates',
        customFrom: 'From',
        customTo: 'To',
        selectDate: 'Select date',
        // Tab extras
        noOrderData: 'No order data for this period',
        compareMode: 'Compare',
        filterByStatus: 'Filter by status',
        location: 'Location',
        stockProducts: 'Products',
        rate: 'Rate',
        // General
        noData: 'No data for this period',
        loading: 'Loading analytics...',
        couponsTotal: 'Coupons Total',
        timezone: 'Timezone',
    },
    notifications: {
        title: 'Notifications',
        markRead: 'Mark as Read',
        markAllRead: 'Mark All Read',
        noNotifications: 'No notifications',
        preferences: 'Notification Preferences',
        unread: 'Unread',
        orderNotifications: 'Orders',
        stockNotifications: 'Stock',
        systemNotifications: 'System',
        newOrder: 'New Order',
        viewAll: 'View All',
        statusChanges: 'Status Changes',
        lowStock: 'Low Stock',
        lowStockAlerts: 'Low Stock Alerts',
        refundAlerts: 'Refund Alerts',
        backorderAlerts: 'Backorder Alerts',
        dailySummary: 'Daily Summary',
        prefsSaved: 'Notification preferences saved',
        prefsDescription: 'Choose which notifications you want to receive for this store.',
        orderStatusChanged: 'Order Status Changes',
        refundRequest: 'Refund Requests',
        productBackorder: 'Product Backorders',
        deleteAll: 'Delete All',
        confirmDeleteAll: 'Delete all notifications?',
        allDeleted: 'All notifications deleted',
        allStores: 'All Stores',
        tpl: {
            newOrderTitle: 'New Order #{{number}}',
            newOrderBody: '{{name}} placed an order for {{currency}} {{total}}',
            statusChangedTitle: 'Order #{{number}} Updated',
            statusChangedBody: 'Status changed from {{oldStatus}} to {{newStatus}}',
            lowStockTitle: 'Low Stock: {{product}}',
            lowStockBody: 'Only {{quantity}} units remaining (SKU: {{sku}})',
            refundTitle: 'Refund on Order #{{orderId}}',
            refundBody: '{{amount}} refunded. Reason: {{reason}}',
            backorderTitle: 'Backorder: {{product}}',
            backorderBody: '{{product}} is on backorder (SKU: {{sku}})',
        },
    },
    settings: {
        title: 'Settings',
        profile: 'Profile',
        stores: 'Connected Stores',
        appearance: 'Appearance',
        language: 'Language',
        theme: 'Theme',
        integrations: 'Integrations',
        about: 'About',
        notificationPrefs: 'Notifications',
        themeLight: 'Light',
        themeDark: 'Dark',
        themeSystem: 'System',
        dateFormat: 'Date Format',
        itemsPerPage: 'Items per page',
        emailReadOnly: 'Contact admin to change email',
        firstName: 'First Name',
        lastName: 'Last Name',
        avatarUrl: 'Avatar URL',
        storeUrl: 'Store URL',
        wcKey: 'WooCommerce Key',
        wcSecret: 'WooCommerce Secret',
        bridgeKey: 'Bridge Key',
        storeName: 'Store Name',
        account: 'Account',
        session: 'Session',
        security: 'Security',
        biometricLogin: 'Biometric Login',
        editProfile: 'Edit Profile',
        confirmLogout: 'Log out of WooConnect?',
        confirmLogoutMessage: 'You will need to log in again to access your stores.',
        support: 'Support',
        preferences: 'Preferences',
        passwordMinLength: 'Password must be at least 8 characters',
        passwordsMustMatch: 'Passwords must match',
        passwordChanged: 'Password changed successfully',
        profileSaved: 'Profile saved successfully',
    },
    sites: {
        title: 'Stores',
        addStore: 'Connect Store',
        testConnection: 'Test Connection',
        disconnect: 'Disconnect',
        health: 'Health',
        online: 'Online',
        offline: 'Offline',
        noSites: 'No stores connected',
        editStore: 'Edit Store',
        confirmDisconnect: 'This will remove access for all users assigned to this store. Are you sure?',
        connectionSuccess: 'Store connected successfully',
        connectionFailed: 'Connection failed',
        testSuccess: 'Connection test passed',
        testFailed: 'Connection test failed',
        wcConnected: 'WooCommerce: Connected',
        wcFailed: 'WooCommerce: Failed',
        bridgeConnected: 'Bridge: Connected',
        bridgeFailed: 'Bridge: Not connected',
        bridgeNotInstalled: 'Bridge: Not installed',
        currency: 'Currency',
        timezone: 'Timezone',
        connectedSince: 'Connected',
        wcVersion: 'WC Version',
        wpVersion: 'WP Version',
        bridgeVersion: 'Bridge Version',
        bridgeLabel: 'Bridge {{version}}',
        urlMustBeHttps: 'URL must start with https://',
        invalidWcKey: 'Must start with ck_',
        invalidWcSecret: 'Must start with cs_',
    },
    subscription: {
        title: 'Subscription',
        plan: 'Plan',
        status: 'Status',
        expiresAt: 'Expires',
        extend: 'Extend',
        changePlan: 'Change Plan',
        maxSites: 'Max Sites',
        priceAmount: 'Price',
        plans: {
            free_trial: 'Free Trial',
            monthly: 'Monthly',
            yearly: 'Yearly',
            lifetime: 'Lifetime',
            custom: 'Custom',
        },
        statuses: {
            trial: 'Trial',
            active: 'Active',
            expired: 'Expired',
            cancelled: 'Cancelled',
            expiring_soon: 'Expiring Soon',
            grace_period: 'Grace Period',
        },
    },
    plugins: {
        title: 'Plugins',
        installed: 'Installed',
        notInstalled: 'Not Installed',
        required: 'Required',
        getPlugin: 'Get Plugin',
        notifyAdmin: 'Request Plugin',
        addPlugin: 'Add Plugin',
        noPlugins: 'No plugins registered',
        bridgeTitle: 'WooConnect Bridge Plugin',
        bridgeDescription: 'Required WordPress plugin that connects your WooCommerce store to the WooConnect platform. Install it on each store you want to manage.',
        installGuide: 'Installation Guide',
        step1: 'Download the ZIP file using the button below',
        step2: 'In WordPress, go to Plugins > Add New > Upload Plugin',
        step3: 'Upload the ZIP file and click Install Now',
        step4: 'Activate the plugin and enter the Bridge API Key from your store settings',
        downloadBridge: 'Download Plugin',
        bridgeVersion: 'Version',
        bridgeRequirements: 'Requirements',
        bridgeRequiresWP: 'WordPress {{version}}+',
        bridgeRequiresPHP: 'PHP {{version}}+',
        bridgeRequiresWC: 'WooCommerce {{min}}+ (tested up to {{max}})',
        bridgeWhatsNew: "What's New",
        copySteps: 'Copy Steps',
        copied: 'Copied',
        installSteps: '1. Download the ZIP file\n2. In WordPress: Plugins > Add New > Upload Plugin\n3. Upload ZIP and click Install Now\n4. Activate and enter Bridge API Key from store settings',
    },
    ai: {
        title: 'AI Assistant',
        chat: 'Chat',
        composeEmail: 'Compose Email',
        businessProfile: 'Business Profile',
        usage: 'AI Usage',
        totalCost: 'Total Cost This Month',
        requestsByFeature: 'Requests by Feature',
        costByUser: 'Cost by User',
        aiEnabled: 'AI Enabled',
        defaultModel: 'Default Model',
        maxTokens: 'Max Tokens',
        usageLimits: 'Usage Limits',
        requests: 'Requests',
        cost: 'Cost',
        totalRequests: 'Total Requests',
        features: 'features',
    },
    admin: {
        title: 'Admin',
        users: 'Users',
        createUser: 'Create User',
        editUser: 'Edit User',
        resetPassword: 'Reset Password',
        changeStatus: 'Change Status',
        userDetail: 'User Detail',
        noUsers: 'No users found',
        subscriptions: 'Subscriptions',
        extendSubscription: 'Extend Subscription',
        days30: '+30 Days',
        days90: '+90 Days',
        year1: '+1 Year',
        custom: 'Custom',
        noSubscriptions: 'No subscriptions found',
        auditLog: 'Audit Log',
        noAuditLogs: 'No audit logs found',
        action: 'Action',
        user: 'User',
        site: 'Site',
        time: 'Time',
        ipAddress: 'IP Address',
        settings: 'App Settings',
        settingKey: 'Key',
        settingValue: 'Value',
        editSetting: 'Edit Setting',
        expiringWithin: 'Expiring within',
        days: 'days',
        plugins: 'Plugins',
        addPlugin: 'Add Plugin',
        noPlugins: 'No plugins registered',
        appSettings: 'App Settings',
        section: 'Admin',
        deleteUser: 'Delete User',
        confirmDeleteUser: 'This will deactivate the user and revoke all sessions. Are you sure?',
        resetPasswordDesc: 'Set a new password for this user. They will be logged out of all sessions.',
        assignStore: 'Assign Store',
        unassignStore: 'Remove Store',
        confirmUnassignStore: 'This will remove store access for this user. Are you sure?',
        editPermissions: 'Edit Permissions',
        permissions: 'Permissions',
        assignedStores: 'Assigned Stores',
        noAssignedStores: 'No stores assigned to this user',
        allStoresAssigned: 'All stores are already assigned to this user',
        selectStore: 'Select a store',
        changePlan: 'Change Plan',
        notes: 'Notes',
        roleDefaults: 'Role Defaults',
        roleDefaultsTitle: 'Default Permissions by Role',
        roleDefaultsDescription: 'Configure which permissions each role gets by default when assigned to a store. Changes only affect new assignments -- existing user permissions remain unchanged.',
        roleDefaultsSaved: 'Role defaults saved',
        roleDefaultsReset: 'Reset to defaults',
        roleDefaultsResetConfirm: 'Reset all role defaults to the built-in values?',
        roleDefaultsNoChanges: 'No changes to save',
    },
    adminSettings: {
        aiEnabled: 'AI Enabled',
        aiEnabledDesc: 'Global AI feature toggle',
        aiModel: 'AI Model',
        aiModelDesc: 'Default Claude model',
        aiMaxTokens: 'AI Max Tokens',
        aiMaxTokensDesc: 'Max tokens per AI request',
        maintenance: 'Maintenance Mode',
        maintenanceDesc: 'Enable maintenance mode',
        versionIos: 'iOS Version',
        versionIosDesc: 'Current iOS app version',
        versionPanel: 'Panel Version',
        versionPanelDesc: 'Current panel version',
        bridgeVersion: 'Min Bridge Version',
        bridgeVersionDesc: 'Minimum required bridge plugin version',
        cacheDashboard: 'Dashboard Cache (sec)',
        cacheDashboardDesc: 'Dashboard cache time in seconds',
        cacheOrders: 'Orders Cache (sec)',
        cacheOrdersDesc: 'Orders cache time in seconds',
        cacheProducts: 'Products Cache (sec)',
        cacheProductsDesc: 'Products cache time in seconds',
        graceDays: 'Grace Days',
        graceDaysDesc: 'Days after expiry before deactivation',
        notifyDays: 'Notification Days',
        notifyDaysDesc: 'Days before expiry to send notification',
        apiDocsTitle: 'API Documentation',
        apiDocsDesc: 'Opens in a new tab',
    },
    auditLog: {
        auth: { login: 'Login', logout: 'Logout', password_changed: 'Password Changed' },
        user: { created: 'User Created', updated: 'User Updated', status_changed: 'Status Changed' },
        site: { connected: 'Store Connected', disconnected: 'Store Disconnected' },
        order: { status_changed: 'Order Status Changed', note_added: 'Note Added', refund_created: 'Refund Created' },
        product: { updated: 'Product Updated' },
        settings: { updated: 'Settings Updated' },
        subscription: { updated: 'Subscription Updated', extended: 'Subscription Extended' },
        permission: { assigned: 'Permission Assigned' },
    },
    roles: {
        super_admin: 'Super Admin',
        admin: 'Admin',
        user: 'User',
        store_owner: 'Store Owner',
        manager: 'Manager',
        staff: 'Staff',
    },
    permissions: {
        ordersView: 'View Orders',
        ordersEdit: 'Edit Orders',
        ordersRefund: 'Refund Orders',
        productsView: 'View Products',
        productsEdit: 'Edit Products',
        customersView: 'View Customers',
        analyticsView: 'View Analytics',
        analyticsAdvanced: 'Advanced Analytics',
        notificationsEnabled: 'Notifications',
        settingsView: 'View Settings',
        settingsEdit: 'Edit Settings',
        aiChat: 'AI Chat',
    },
    marketing: {
        title: 'Marketing',
        test: 'Test',
        compose: 'Compose',
        templates: 'Templates',
        history: 'History',
        queue: 'Queue',
        testSend: 'Test Send',
        recipient: 'Recipient',
        channels: 'Channels',
        push: 'Push Notification',
        email: 'Email',
        panelNotification: 'Panel Notification',
        allChannels: 'All channels',
        messageTitle: 'Title',
        messageBody: 'Message',
        deepLink: 'Deep Link',
        deepLinkNone: 'None',
        deepLinkDashboard: 'Dashboard',
        deepLinkOrder: 'Order',
        deepLinkUrl: 'External URL',
        sendTest: 'Send Test',
        testHistory: 'Test History',
        result: 'Result',
        delivered: 'Delivered',
        sent: 'Sent',
        failed: 'Failed',
        pending: 'Pending',
        sending: 'Sending',
        cancelled: 'Cancelled',
        draft: 'Draft',
        newCampaign: 'New Campaign',
        template: 'Template',
        noTemplate: 'No template',
        recipients: 'Recipients',
        allActiveUsers: 'All active users',
        byRole: 'By role',
        specificUsers: 'Specific users',
        sendNow: 'Send now',
        scheduleFor: 'Schedule for',
        scheduled: 'Scheduled',
        preview: 'Preview',
        testToMe: 'Test to me',
        sendOrSchedule: 'Send / Schedule',
        newTemplate: 'New Template',
        templateName: 'Template name',
        templateCategory: 'Category',
        variables: 'Variables',
        systemTemplate: 'System template',
        customTemplate: 'Custom',
        welcome: 'Welcome',
        reminder: 'Reminder',
        summary: 'Report',
        promo: 'Promotional',
        alert: 'Alert',
        custom: 'Custom',
        exportCsv: 'Export CSV',
        campaignDetail: 'Campaign Details',
        recipientResults: 'Results per recipient',
        scheduledMessages: 'Scheduled Messages',
        edit: 'Edit',
        cancel: 'Cancel',
        sendImmediately: 'Send Now',
        confirmCancel: 'Cancel this scheduled message?',
        confirmSendNow: 'Send this message now?',
        confirmDelete: 'Delete this template?',
        hasPushToken: 'Has Push Token',
        noPushToken: 'No Push Token',
        usersWithTokens: '{{count}} users with push token',
        totalRecipients: 'Total recipients',
        deliveredCount: 'Delivered',
        failedCount: 'Failed',
        openedCount: 'Opened',
        noTestHistory: 'No test notifications sent yet',
        noCampaigns: 'No campaigns yet',
        noTemplates: 'No templates yet',
        noScheduled: 'No scheduled messages',
        selectUser: 'Select user',
        selectRole: 'Select role',
        selectUsers: 'Select users',
        campaignSent: 'Campaign sent successfully',
        testSentSuccess: 'Test notification sent',
        templateCreated: 'Template created',
        templateUpdated: 'Template updated',
        templateDeleted: 'Template deleted',
        campaignCancelled: 'Campaign cancelled',
        date: 'Date',
        status: 'Status',
        actions: 'Actions',
        viewDetails: 'View details',
        back: 'Back',
        close: 'Close',
        save: 'Save',
        create: 'Create',
        smtpNotConfigured: 'SMTP not configured',
        selectTemplate: 'Select template',
        noActiveTokens: 'No active push tokens',
    },
    apiKeys: {
        title: 'API Keys',
        create: 'Create API Key',
        name: 'Key Name',
        scopes: 'Scopes',
        prefix: 'Key Prefix',
        lastUsed: 'Last Used',
        expires: 'Expires',
        never: 'Never',
        neverUsed: 'Never used',
        active: 'Active',
        revoked: 'Revoked',
        revoke: 'Revoke',
        copyWarning: 'Copy this key now. It will not be shown again.',
        noKeys: 'No API keys created',
        created: 'API key created',
        updated: 'API key updated',
        deleted: 'API key revoked',
        scopeReadOrders: 'Read Orders',
        scopeWriteOrders: 'Write Orders',
        scopeReadProducts: 'Read Products',
        scopeWriteProducts: 'Write Products',
        scopeReadCustomers: 'Read Customers',
        scopeReadAnalytics: 'Read Analytics',
        scopeReadDashboard: 'Read Dashboard',
        scopeReadNotifications: 'Read Notifications',
        scopeWriteNotifications: 'Write Notifications',
        allScopes: 'Full Access',
        site: 'Linked Store',
        allSites: 'All Stores',
    },
    webhooks: {
        title: 'Webhooks',
        endpoints: 'Endpoints',
        create: 'Create Endpoint',
        url: 'Destination URL',
        events: 'Events',
        secret: 'Signing Secret',
        description: 'Description',
        headers: 'Custom Headers',
        active: 'Active',
        disabled: 'Disabled',
        failCount: 'Consecutive Failures',
        disabledAt: 'Auto-disabled at',
        reactivate: 'Reactivate',
        testEvent: 'Send Test Event',
        deliveries: 'Recent Deliveries',
        noEndpoints: 'No webhook endpoints configured',
        noDeliveries: 'No deliveries yet',
        created: 'Webhook endpoint created',
        updated: 'Webhook endpoint updated',
        deleted: 'Webhook endpoint deleted',
        reactivated: 'Webhook endpoint reactivated',
        testSent: 'Test event sent',
        eventNewOrder: 'New Order',
        eventStatusChanged: 'Order Status Changed',
        eventLowStock: 'Low Stock',
        eventRefundCreated: 'Refund Created',
        eventBackorder: 'Product Backorder',
        eventSubExpiring: 'Subscription Expiring',
        eventSubExpired: 'Subscription Expired',
        eventBridgeOffline: 'Bridge Offline',
        attempt: 'Attempt',
        statusCode: 'Status Code',
        duration: 'Duration',
        site: 'Linked Store',
        allSites: 'All Stores',
    },
};
//# sourceMappingURL=en.js.map